export const SITES = [
  "ATLB-S1","DFWA-S1","DFWB-S1","IADA-S1","IADB-S1",
  "LAXA-S1","LAXA-S2","LAXA-S3","LAXB-S1","LGAB-S1",
  "ORDB-S1","SEAA-S1","SEAA-S2","SJCB-S1","SJCB-S2",
  "FRAA-S1","FRAA-S2","FRAA-S3","FRAB-S1","FRAB-S2","FRAB-S3",
  "LONA-S1","LONA-S2","LONB-S1","LONB-S2","LONB-S3",
  "MADA-S1","MADB-S1","MADB-S2","MILA-S1","MILA-S2",
  "PARA-S1","PARB-S1","STOA-S1","STOA-S2","TYOB-S1","TYOB-S2",
];

export const SITE_DETAILS = {
  "ATLB-S1":{name:"Centersquare ATL1-D",city:"Lithia Springs, GA",country:"USA"},
  "DFWA-S1":{name:"Aligned Datacenters",city:"Plano, TX",country:"USA"},
  "DFWB-S1":{name:"Evocative DAL6",city:"Plano, TX",country:"USA"},
  "IADA-S1":{name:"Iron Mountain VA-1",city:"Manassas, VA",country:"USA"},
  "IADB-S1":{name:"H5 Data Centers",city:"Chantilly, VA",country:"USA"},
  "LAXA-S1":{name:"CoreSite LA2 (301-01/02)",city:"Los Angeles, CA",country:"USA"},
  "LAXA-S2":{name:"CoreSite LA2 (LL-LL1C PODB)",city:"Los Angeles, CA",country:"USA"},
  "LAXA-S3":{name:"CoreSite LA2 (LL-LL1A-0104)",city:"Los Angeles, CA",country:"USA"},
  "LAXB-S1":{name:"Centersquare LAX5-A",city:"Irvine, CA",country:"USA"},
  "LGAB-S1":{name:"Iron Mountain NJE-1",city:"Edison, NJ",country:"USA"},
  "ORDB-S1":{name:"Digital Crossroad DX-1",city:"Hammond, IN",country:"USA"},
  "SEAA-S1":{name:"Centeris SouthHills",city:"Puyallup, WA",country:"USA"},
  "SEAA-S2":{name:"Centeris SouthHills (S2)",city:"Puyallup, WA",country:"USA"},
  "SJCB-S1":{name:"Fulcrum (Colo 4)",city:"San Francisco, CA",country:"USA"},
  "SJCB-S2":{name:"Fulcrum (Colo 3)",city:"San Francisco, CA",country:"USA"},
  "FRAA-S1":{name:"Telehouse Frankfurt (S1)",city:"Frankfurt",country:"Germany"},
  "FRAA-S2":{name:"Telehouse Frankfurt (S2)",city:"Frankfurt",country:"Germany"},
  "FRAA-S3":{name:"Telehouse Frankfurt (S3)",city:"Frankfurt",country:"Germany"},
  "FRAB-S1":{name:"Global Switch Frankfurt (S1)",city:"Frankfurt",country:"Germany"},
  "FRAB-S2":{name:"Global Switch Frankfurt (S2)",city:"Frankfurt",country:"Germany"},
  "FRAB-S3":{name:"Global Switch Frankfurt (S3)",city:"Frankfurt",country:"Germany"},
  "LONA-S1":{name:"NTT HH2 Maylands",city:"Hemel Hempstead",country:"UK"},
  "LONA-S2":{name:"NTT HH3 Campus",city:"Hemel Hempstead",country:"UK"},
  "LONB-S1":{name:"Global Switch London (A04)",city:"London",country:"UK"},
  "LONB-S2":{name:"Global Switch London (A03)",city:"London",country:"UK"},
  "LONB-S3":{name:"Global Switch London (C09)",city:"London",country:"UK"},
  "MADA-S1":{name:"Global Switch Madrid",city:"Madrid",country:"Spain"},
  "MADB-S1":{name:"NTT Madrid (Suite 320)",city:"Las Rozas de Madrid",country:"Spain"},
  "MADB-S2":{name:"NTT Madrid (Suite 340)",city:"Las Rozas de Madrid",country:"Spain"},
  "MILA-S1":{name:"Aruba IT3",city:"Ponte San Pietro",country:"Italy"},
  "MILA-S2":{name:"Aruba DC-B",city:"Ponte San Pietro",country:"Italy"},
  "PARA-S1":{name:"Colt PA2",city:"Les Ulis",country:"France"},
  "PARB-S1":{name:"Azur Datacenter",city:"Croissy-Beaubourg",country:"France"},
  "STOA-S1":{name:"Global Connect (Zone 3)",city:"Skärholmen",country:"Sweden"},
  "STOA-S2":{name:"Global Connect (Zone 4)",city:"Skärholmen",country:"Sweden"},
  "TYOB-S1":{name:"Fujitsu Yokohama (Room L)",city:"Yokohama",country:"Japan"},
  "TYOB-S2":{name:"Fujitsu Yokohama (Room M)",city:"Yokohama",country:"Japan"},
};
